import ArrowDownIcon from "./arrow_down.svg";
import ArrowUpIcon from "./arrow_up.svg";
import TrashIcon from "./trash.svg";
import GearIcon from "./gear.svg";
import Palette from "./palette.svg";

export { ArrowDownIcon, ArrowUpIcon, TrashIcon, GearIcon, Palette };
